import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  TableContainer,
  Alert,
} from "@mui/material";
import VantageListHead from "../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
} from "../../../component/Methods";

const SwapRebalanceItems = ({
  filteredContracts,
  tableHeader,
  hasValidationErrors,
  filteredStrategies,
  fillHeight = false,
}) => {
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("executionStyle");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    const transformedData = filteredContracts?.flatMap((contract) => {
      if (!contract?.updatedParameters) return [];
      return contract?.updatedParameters?.map((param) => ({
        name: param?.stockId,
        id: contract.id,
        executionStyle: param?.executionStyle,
        newWeight: param?.newWeight,
        currentWeight: param?.currentWeight,
      }));
    });

    const filteredUsers = applySortFilter(
      transformedData,
      getComparator(order, orderBy)
    );

    setData(filteredUsers);
  }, [
    order,
    orderBy,
    filteredContracts,
    hasValidationErrors,
    filteredStrategies,
  ]);

  return (
    <>
      {data && data?.length > 0 ? (
        <Box
          sx={{
            borderRadius: "4px",
            marginTop: fillHeight ? 0 : "20px",
            width: "100%",
            ...(fillHeight && {
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }),
          }}
        >
          <TableContainer
            sx={{
              width: "100%",
              ...(fillHeight
                ? {
                    flex: "1 1 0px",
                    minHeight: 0,
                    height: 0,
                    maxHeight: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    display: "block",
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: "4px",
                  }
                : {
                    height: "700px",
                    overflow: "auto",
                  }),
            }}
          >
            <Table
              size="small"
              stickyHeader
              aria-label="a dense table"
              sx={{
                height: "max-content",
              }}
            >
              <VantageListHead
                order={order}
                orderBy={orderBy}
                headLabel={tableHeader}
                noStatus={true}
                customizeFont={12}
                rowCount={data.length}
                onRequestSort={handleRequestSort}
              />

              <TableBody>
                {data?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        background: theme.palette.grey[200],
                        cursor: "pointer",
                      },
                    }}
                  >
                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.name?.toUpperCase() || ""}
                    </Tablecell>
                    <Tablecell
                      align="right"
                      style={{
                        fontSize: "12px",
                        paddingRight: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.executionStyle}
                    </Tablecell>

                    <Tablecell
                      align="right"
                      style={{
                        fontSize: "12px",
                        paddingRight: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                     
                      {row?.currentWeight < 0
                        ? `(${
                            Math.abs(row.currentWeight)?.toFixed(4)
                          })`
                        : row.currentWeight?.toFixed(4)}
                    </Tablecell>
                    <Tablecell
                      align="right"
                      style={{
                        fontSize: "12px",
                        paddingRight: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.newWeight < 0
                        ? `(${Math.abs(row.newWeight).toFixed(4)})`
                        : row.newWeight.toFixed(4)}
                    </Tablecell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}
    </>
  );
};

export default SwapRebalanceItems;
